<div class="card-highlight" [ngStyle]="{'align-items': index === 1 ? 'flex-start' : ''}">
    <div [innerHTML]="data.text" class="text"></div>
    <div>
        <picture  *ngIf="data.image">
            <img  [src]="data.image.url" [alt]="data.name">
        </picture>
    </div>
</div>
